import request from "@/utils/request";
/******综合查询*****/
//会员考评信息查询导出
export function exportMemberScore(data) {
  return request({
    url: "/memberscore/export",
    method: "post",
    data,
    responseType: "blob",
  });
}
//单位端办理或查询工作导出
export function exportWorkInfoExcel(data) {
  return request({
    url: "/work/export",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 会员申请信息查询导出
export function exportMemberApplyInfo(data) {
  return request({
    url: "/form/member/export",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 会员申请信息导出Pdf
export function exportMemberApplyPdf(data) {
  return request({
    url: "/form/member/export/pdf",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 会员变更信息导出Pdf
export function exportMemberChangePdf(data) {
  return request({
    url: "/form/membermodify/export/pdf",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 会员退会信息导出Pdf
export function exportMemberOutPdf(data) {
  return request({
    url: "/form/memberout/export/pdf",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 导出两年未缴费信息查询结果
export function exportMemberOut(data) {
  return request({
    url: "/form/memberout/export",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 会员变更信息查询导出
export function exportMemberUpdateInfo(data) {
  return request({
    url: "/form/membermodify/export",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 会员简介信息查询导出
export function exportMemberUnitInfo(data) {
  return request({
    url: "/form/memberunit/export",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 会员简介变更信息查询导出
export function exportMemberUnitUpdateInfo(data) {
  return request({
    url: "/form/memberunitmodify/export",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 缴费申请信息查询导出
export function exportFormMemberPayInfo(data) {
  return request({
    url: "/form/memberpay/export",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 工程奖项目信息查询导出
export function exportFormProjAwardAllInfo(data) {
  return request({
    url: "/form/projAwardallbasic/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 用户信息查询导出
export function exportUserInfo(data) {
  return request({
    url: "/user/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 报名信息查询导出
export function exportSignupInfo(data) {
  return request({
    url: "/activity/signup/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 比赛报名信息查询导出
export function exportYmqSignupInfo(data) {
  return request({
    url: "/activity/signup/export/ymq",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 会员信息查询导出
export function exportMemberInfo(data) {
  return request({
    url: "/member/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 缴费信息查询导出
export function exportMemberPayInfo(data) {
  return request({
    url: "/memberPay/export/pay",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 考评一览表导出
export function exportMemberScorePdfInfo(data) {
  return request({
    url: "/memberscore/export/pdf",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 会费缴纳公示导出
export function exportMemberPayPublicInfo(data) {
  return request({
    url: "/memberPay/export/public",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 投诉提案导出
export function exportCaseBasicInfo(data) {
  return request({
    url: "/form/casebasic/export",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 简介文档导出
export function exportMemberUnitDocument(data) {
  return request({
    url: `/form/memberunit/export/${data.workId}`,
    method: "post",
    data,
    responseType: "blob",
  });
}
// 单位简介变更文档导出
export function exportMemberChangeUnitDocument(data) {
  return request({
    url: `/form/memberunitmodify/export/${data.workId}`,
    method: "post",
    data,
    responseType: "blob",
  });
}
// 导出项目压缩包
export function exportZip(data) {
  return request({
    url: `/form/resource/zip`,
    method: "post",
    data,
    responseType: "blob",
    timeout:20000
  });
}

// 单位简介附件下载
export function exportUnitIntroduceZip(data) {
  return request({
    url: "/form/resource/zip",
    method: "post",
    data,
    responseType: "blob",
  });
}
// 导出参赛人员
export function exportBaoming(data) {
  return request({
    url: "/activity/signup/export/pdf",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 导出专家信息
export function exportExpertInfo(data) {
  return request({
    url: "/expert/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 产业监测 省级管理员专用 导出接口
export function exportUnitInfoByProvincial(data) {
  return request({
    responseType: "blob",
    url: "/excel/export/excelCyjcUnitInfoByProvincial",
    method: "post",
    data,
  });
}

// ==============
// 导出终评分组信息
export function exportTerminalGroupInfo(data) {
  return request({
    url: "/proj/terminal/group/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 导出终评专家信息
export function exportTerminalExpertInfo(data) {
  return request({
    url: `/proj/terminal/group/export/${data.awardYear}/expert`,
    method: "post",
    data,
    responseType: "blob",
  });
}

// 导出终评项目信息
export function exportTerminalProjInfo(data) {
  return request({
    url: `/proj/terminal/group/export/${data.awardYear}/proj`,
    method: "post",
    data,
    responseType: "blob",
  });
}

// 导出工程项目终评评分信息
export function exportTerminalProjScoreInfo(data) {
  return request({
    url: "/proj/terminal/score/export/score",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 导出工程终评按专家统计信息
export function exportTerminalProjByExpertInfo(data) {
  return request({
    url: "/proj/terminal/statistic/expert/export",
    method: "post",
    data,
    responseType: "blob",
  });
}

// 导出工程终评按专家统计分数汇总信息
export function exportTerminalProjByExpertScorePdf(data) {
  return request({
    url: `/proj/terminal/statistic/expert/${data.awardYear}/pdf`,
    method: "post",
    responseType: "blob",
  });
}
// 单位端-导出填报产业监测信息结果Excel
export function exportMonitorDate(params) {
  return request({
    url: `/form/industrydatabasic/export`,
    method: "post",
    responseType: "blob",
    params,
  });
}
// 工程初评管理—评分管理导出
export function getProjCpglManageListExport(data) {
  return request({
    url: `/proj/award/online/review/projCpglManageExport`,
    method: "post",
    responseType: "blob",
    data,
  });
}
// 工程奖初评分组-按项目统分导出
export function getProjCpglPrijectListExport(data) {
  return request({
    url: `/proj/award/online/review/projCpglPrijectExport`,
    method: "post",
    responseType: "blob",
    data,
  });
}
// 工程奖初评分组-按专家统计导出
export function getprojCpglExpertCountExport(data) {
  return request({
    url: `/proj/award/online/review/projCpglExpertCountExport`,
    method: "post",
    responseType: "blob",
    data,
  });
}
// 工程奖初评分组-按分组统分导出
export function getprojCpglGroupCountExport(data) {
  return request({
    url: `/proj/award/online/review/projCpglGroupCountExport`,
    method: "post",
    responseType: "blob",
    data,
  });
}

// 导出工程初评按专家统计分数汇总信息
export function exportProjByExpertScorePdf(data) {
  return request({
    url: `/proj/award/online/review/expert/${data.awardYear}/pdf`,
    method: "post",
    responseType: "blob",
  });
}

// 专家使用说明
export function exportCommDownFile(data) {
  return request({
    url: `/form/resource/file?data=${data}`,
    method: "get",
    responseType: "blob",
    timeout:600000
  });
}

export default {
  exportMemberScore,
  exportWorkInfoExcel,
  exportMemberApplyInfo,
  exportMemberApplyPdf,
  exportMemberChangePdf,
  exportMemberOutPdf,
  exportMemberOut,
  exportMemberUpdateInfo,
  exportMemberUnitInfo,
  exportMemberUnitUpdateInfo,
  exportFormMemberPayInfo,
  exportFormProjAwardAllInfo,
  exportUserInfo,
  exportSignupInfo,
  exportYmqSignupInfo,
  exportMemberInfo,
  exportMemberPayInfo,
  exportMemberScorePdfInfo,
  exportMemberPayPublicInfo,
  exportCaseBasicInfo,
  exportMemberUnitDocument,
  exportMemberChangeUnitDocument,
  exportZip,
  exportUnitIntroduceZip,
  exportExpertInfo,

  exportTerminalGroupInfo,
  exportTerminalExpertInfo,
  exportTerminalProjInfo,
  exportTerminalProjScoreInfo,
  exportTerminalProjByExpertInfo,
  exportTerminalProjByExpertScorePdf,
  exportCommDownFile,
};
